import { useState, useMemo } from "react"
import { DataTable } from "./DataTable"
import { DataChart, analyzeData } from "./DataChart"

interface DataResultViewProps {
  data: Array<Record<string, string | number>>
}

export function DataResultView({ data }: DataResultViewProps) {
  const [view, setView] = useState<"table" | "chart">("table")
  const analysis = useMemo(() => analyzeData(data), [data])

  return (
    <div>
      {analysis && (
        <div className="flex gap-1 mb-1">
          <button
            type="button"
            className={`btn btn-xs ${view === "table" ? "btn-active" : "btn-ghost"}`}
            onClick={() => setView("table")}
          >
            Table
          </button>
          <button
            type="button"
            className={`btn btn-xs ${view === "chart" ? "btn-active" : "btn-ghost"}`}
            onClick={() => setView("chart")}
          >
            Chart
          </button>
        </div>
      )}
      {view === "table" || !analysis ? (
        <DataTable data={data} />
      ) : (
        <DataChart data={data} analysis={analysis} />
      )}
    </div>
  )
}
